export type IGetGtmEcommercePropertyPropsShort = {
    id: number;
    number: string;
};

export type IGetGtmEcommercePropertyPropsFull = {
    id: number;
    number: string;
    area?: number;
    height_range?: {
        upper?: number;
    };
    rooms?: number;
    floor?: number;
};

export type IGetGtmEcommercePropertyProps =
    | {
          short: true;
          property: IGetGtmEcommercePropertyPropsShort;
      }
    | {
          short: false;
          property: IGetGtmEcommercePropertyPropsFull;
      };

export const getGTMEcommercePropertyProps = (params: IGetGtmEcommercePropertyProps) => {
    if (params.short) {
        return {
            variant: params.property.id.toString(),
            variant_name: params.property.number
        };
    } else {
        return {
            variant: params.property.id.toString(),
            variant_name: params.property.number,
            ...(params.property.area
                ? {
                      variant_area: params.property.area.toString()
                  }
                : {}),
            ...(params.property.height_range?.upper
                ? {
                      variant_room_height: params.property.height_range.upper.toString()
                  }
                : {}),
            ...(params.property.rooms
                ? {
                      variant_rooms: params.property.rooms.toString()
                  }
                : {}),
            ...(params.property.floor
                ? {
                      variant_floor: params.property.floor.toString()
                  }
                : {})
        };
    }
};
